import "./StyleKpiElement.css"

function ProgressBar({ initialValue, zone }) {

    const getColorProgressBar = (zone) =>{
        if(zone ===  "red"){
            return "var(--progressBarGradientRed)";
        }else if (zone ===  "yellow"){
            return "var(--progressBarGradientOrange)";
        }else{
            return "var(--progressBarGradientGreen)";
        }
    }
    const getColor = (zone) =>{
        if(zone ===  "red"){
            return "var(--redColor)";
        }else if (zone ===  "yellow"){
            return "var(--orangeColor)";
        }else{
            return "var(--greenColor)";
        }
    }

    return (
        <>
            <div className="container">
                <div className="progress-container">
                    <div
                        className="progress-bar"
                        id={"progressBar"}
                        style={
                            {
                                width: `${(initialValue*100).toFixed(1)}%`,
                                background: getColorProgressBar(zone)
                            }
                        }
                    ></div>
                </div>
                <span style={{color: getColor(zone)}}>{(initialValue*100).toFixed(1)}%</span>
            </div>
        </>
    );
}

export default ProgressBar;